<template>
    <Modal class-name="vertical-center-modal" v-model="isModal" title="已购套餐详情">
        <div class="nickName">推荐的好友：{{ userForm.nickname }}</div>
        <Table border :columns="columns" :data="list" :loading="loading"></Table>
        <div style="padding: 10px 0px">
            <Page  :total="total" :current="searchForm.pageNo" show-elevator show-total @on-change="changePage"
                   @on-page-size-change="changePagesize"></Page>
        </div>
        <div slot="footer">
            <div class="footer-wrapper">
                <span class="btn confirm-btn" @click="handelCancel">确定</span>
            </div>
        </div>
        <Spin size="large" fix v-show="loading"></Spin>
    </Modal>
</template>

<script>
    import { Modal, Spin, Table, Page } from 'view-design'
    import invite from '@/javaApi/invite'
    const inviteModel = new invite()
    export default {
        name: "Detail",
        components: {
            Modal,
            Spin,
            Table,
            Page
        },
        data: function() {
            return {
                isModal: false,
                loading: false,
                columns: [
                    {
                        title: '套餐类型',
                        key: 'name',
                    },
                    {
                        title: '支付费用',
                        key: 'money',
                    },
                    {
                        title: '支付时间',
                        key: 'payTimeStr',
                        width: 200
                    }
                ],
                list:[],
                total:0,
                searchForm: {
                    pageNo: 1,
                    pageSize: 10,
                },
                userForm: {}
            }
        },
        created:function(){
        },
        methods: {
            init: function(isModal,row) {
                this.loading = true
                this.isModal = isModal
                this.loading = false
                this.userForm = row
                this.searchForm= {
                    pageNo: 1,
                    pageSize: 10,
                }
                this.tabActive = 0
                this.getList(true)
            },
            handelCancel: function() {
                this.isModal = false
            },
            changePage(value){
                this.searchForm.pageNo = value
                this.getList()
            },
            changePagesize(value){
                this.searchForm.pageSize = value;
                //如果处于第一页改变数量，则会触发changePage
                if(this.searchForm.pageNo == 1){
                    this.getList(true)
                }
            },
            getList(isfirst){
                if(isfirst){
                    this.searchForm.pageNo = 1
                }
                let that =this
                inviteModel.getPackageList({
                    openUserUuid: this.userForm.openUserUuid,
                    pageNo: this.searchForm.pageNo,
                    pageSize: this.searchForm.pageSize
                }).then(response=>{
                    let res = response.data
                    if(res.code == 200){
                        that.list = res.data.list
                        that.total= res.data.total
                    }else{
                        let message = res.message?res.message:'系统异常请稍后再试'
                        that.$message.error(message)
                    }
                }).catch(error=>{
                    if(error != 'token invalid'){
                        that.$message.error('系统异常请稍后再试')
                    }
                })
            }
        }
    }
</script>

<style scoped>
    >>>.vertical-center-modal {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    >>>.vertical-center-modal .ivu-modal {
        top: 0;
        width: 300px;
    }

    >>>.vertical-center-modal .ivu-modal-footer {
        border-top: none;
        padding: 12px 18px 12px 18px;
        text-align: right;
    }

    >>>.ivu-form-item {
        margin-bottom: 0;
    }

    >>> .ivu-table-header th {
        background-color: #FCFAF8 !important;
    }

    .footer-wrapper {
        display: flex;
        min-width: 0;
        width: 100%;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
    }

    .nickName{
        margin-bottom: 15px;
    }

    .footer-wrapper .btn {
        display: inline-block;
        border-radius: 4px;
        margin-right: 10px;
        padding: 0px 15px;
        font-size: 14px;
        height: 32px;
        line-height: 32px;
        vertical-align: middle;
        cursor: pointer;
    }

    .footer-wrapper .btn.confirm-btn {
        background: #ff8622;
        color: #fff;
    }

    .footer-wrapper .btn.cancel-btn {
        border: 1px solid #eeeeee;
        border-radius: 2px;
        color: #222222;
    }
</style>



// WEBPACK FOOTER //
// src/views/pc/official/invite/modal/Detail.vue